import {leadApiGet} from "./api";
import {fixWizardItem} from "../wizardLogic/wizardLogic";

export const getWizardListFromBackend = async () => {
  // const mainResponse = await leadApiGet(`/api/public/bvdata/${document.kvConfig.userId}/30?mode=leadForm`);
  const mainResponse = await leadApiGet(`/api/Public/Wizard/Get/${document.kvConfig.userId}/leadform`);
  // if (mainResponse.data) {
  //   console.log("mainResponse", mainResponse.data);
  // }
  if (mainResponse && mainResponse.data) {
    const wizardList = JSON.parse(mainResponse.data)
      .filter(wizardItem => wizardItem.enabled)
      .map((wizardItem, wizardItemIndex) => {
        wizardItem = fixWizardItem(wizardItem, wizardItemIndex,true);
        // wizardItem.id = getUpdatedWizardId(wizardItem.visualizer, wizardItem.id);
        return wizardItem
      });

    return {wizardList, error: mainResponse.data.error}
  }
  return {wizardList: [], error: mainResponse.error}
}
